var _path, _rect, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSolanaBordered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9529 10.3463L11.4671 11.9393C11.435 11.9739 11.3961 12.0015 11.3528 12.0204C11.3095 12.0393 11.2628 12.0491 11.2156 12.0491H4.17262C4.13903 12.0491 4.10618 12.0393 4.07808 12.0209C4.04998 12.0025 4.02785 11.9763 4.01442 11.9455C4.00098 11.9147 3.99682 11.8807 4.00243 11.8476C4.00804 11.8145 4.02319 11.7837 4.04602 11.759L5.53007 10.166C5.56221 10.1314 5.60112 10.1038 5.6444 10.0849C5.68768 10.066 5.73439 10.0562 5.78161 10.0562H12.8246C12.8585 10.0555 12.8918 10.0648 12.9204 10.083C12.949 10.1012 12.9716 10.1275 12.9853 10.1585C12.9991 10.1895 13.0033 10.2239 12.9975 10.2573C12.9917 10.2907 12.9762 10.3217 12.9529 10.3463ZM11.4671 7.13751C11.4349 7.10307 11.3959 7.07557 11.3527 7.05668C11.3094 7.03779 11.2628 7.02793 11.2156 7.02768H4.17262C4.13903 7.0277 4.10618 7.03751 4.07808 7.05592C4.04998 7.07433 4.02785 7.10053 4.01442 7.13131C4.00098 7.1621 3.99682 7.19614 4.00243 7.22925C4.00804 7.26237 4.02319 7.29314 4.04602 7.31779L5.53007 8.91168C5.56233 8.94612 5.60127 8.97362 5.64452 8.99251C5.68777 9.0114 5.73442 9.02126 5.78161 9.02151H12.8246C12.8581 9.02133 12.8908 9.0114 12.9188 8.99293C12.9468 8.97446 12.9688 8.94825 12.9821 8.9175C12.9955 8.88674 12.9996 8.85277 12.9939 8.81973C12.9883 8.78668 12.9732 8.756 12.9504 8.73141L11.4671 7.13751ZM4.17262 5.99303H11.2156C11.2628 5.99299 11.3095 5.9832 11.3528 5.9643C11.3961 5.94541 11.435 5.91779 11.4671 5.88319L12.9529 4.29014C12.9762 4.26553 12.9917 4.23458 12.9975 4.20117C13.0033 4.16775 12.9991 4.13338 12.9853 4.10237C12.9716 4.07136 12.949 4.0451 12.9204 4.02689C12.8918 4.00868 12.8585 3.99934 12.8246 4.00004H5.78161C5.73439 4.00009 5.68768 4.00986 5.6444 4.02876C5.60112 4.04766 5.56221 4.07527 5.53007 4.10987L4.04602 5.70292C4.02319 5.72757 4.00804 5.75834 4.00243 5.79146C3.99682 5.82457 4.00098 5.85861 4.01442 5.88939C4.02785 5.92018 4.04998 5.94638 4.07808 5.96479C4.10618 5.9832 4.13903 5.99301 4.17262 5.99303Z",
    fill: "url(#paint0_linear_3880_9772)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16.0113,
    height: 16,
    rx: 7.5,
    stroke: "url(#paint1_linear_3880_9772)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3880_9772",
    x1: 4.75973,
    y1: 12.241,
    x2: 12.1453,
    y2: 3.91501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8752F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5497D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#43B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28E0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#19FB9B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3880_9772",
    x1: 1.436,
    y1: 17.4052,
    x2: 17.1461,
    y2: 1.55534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8752F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5497D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#43B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28E0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#19FB9B"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolanaBordered);
export default __webpack_public_path__ + "static/media/icon-solana-bordered.3d21ec2291bfd621d4b9d8b4d0352446.svg";
export { ForwardRef as ReactComponent };